import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { isCasualGame } from "@spite/platform-sdk";
import { initializeTheme } from "./theme";
import "./styles.css";

initializeTheme();

const root = createRoot(document.getElementById("root")!);
const embed = window.location.pathname.match(/^\/embed\/([^/]+)\/?$/);
if (embed && isCasualGame(embed[1])) {
  const game = embed[1];
  void import("./casual-embed").then(({ CasualEmbed }) => root.render(<StrictMode><CasualEmbed game={game} /></StrictMode>));
} else {
  void import("./app").then(({ App }) => root.render(<StrictMode><App /></StrictMode>));
}
